jQuery(function($)
{
    /*
	 *var
	 * show = orion.show,
	 *hide = orion.hide,
	 */

    /*
	 * Pseudo-Constants
	 *classCurrent = 'current',
	 */
    var requestUriReplacePatternPageCategory = '[pageCategory]',
        requestUriReplacePatternSearch = '[search]',
        requestUriPattern
			= '/js_catalog/'
				+ requestUriReplacePatternPageCategory
				+ '/pagination/' + requestUriReplacePatternSearch,

        // module-global variables
        $body = $('body'),
        $container = $('nav.pagination-container'),
        idLastRequest = 0;

    if (0 === $container.length)
    {
        return;
    }

    /*
	 * function embellish() {
	 * var
	 * $ul = $("ul", $container),
	 * $li = $("li", $ul),
	 * $prev = $("li.prev", $ul),
	 * $next = $("li.next", $ul);
	 *
	 * if (2 === $li.length) {
	 * hide($container);
	 * return;
	 * } else {
	 * show($container);
	 * }
	 *
	 * if ($prev.next().hasClass(classCurrent)) {
	 * hide($prev);
	 * }
	 *
	 * if ($next.prev().hasClass(classCurrent)) {
	 * hide($next);
	 * }
	 *}
	 */

    function getRequestUri(pageCategory, search)
    {
        return requestUriPattern
            .replace(requestUriReplacePatternPageCategory, pageCategory)
            .replace(requestUriReplacePatternSearch, search);
    }

    function makeRequestPromise(pageCategory, search)
    {
        var
            requestUri = getRequestUri(pageCategory, search),
            requestId = idLastRequest + 1,

            request = $.ajax({
                'dataType': 'html',
                'url': requestUri
            });

        request.requestId = requestId;
        idLastRequest += 1;

        return request;
    }

    function forceReflow()
    {
        /*
		 * Workaround for Webkit-Reflow bug
		 * Under certain circumstances, it seems that Webkit browser do not
		 * appropriately trigger a reflow on layout changes.
		 * Changing the display style, and just accessing the offsetHeight property
		 * will force a reflow, without noticeable flicker for the user.
		 */
        var
            sel = $container.get(0),
            { display } = sel.style;

        sel.style.display = 'none';
        sel.offsetHeight;
        sel.style.display = display;
    }

    function reload()
    {
        var
            pageCategory = orion.toPageCategory(),
            { search } = document.location,
            request = makeRequestPromise(pageCategory, search);

        function handleDone(markup)
        {
            if (idLastRequest !== request.requestId)
            {
                // stale request => discard
                return;
            }

            if (!markup)
            {
                console.log('empty nav.pagination');
                $container.empty();
            }
            else
            {
                console.log('replace nav.pagination');
                $container.empty().append($(markup).children());
            }
        }

        orion.startProcessing('#custom-filter-options, .js-filter-remove-container');
        request
            .done(handleDone)
        // .done(embellish)
            .fail(function()
            {
                // console.log("…pagination request failed");
            })
            .always(function()
            {
                orion.stopProcessing('#custom-filter-options, .js-filter-remove-container');
            });
    }

    // embellish(); // aktuell nicht in Verwendung
    forceReflow();
    $body.on([orion.constants.EventFiltersChanged, orion.constants.EventSortCriteriumChanged].join(' '), reload);
});
